import React from 'react'
import ApplicationTasklist from '../../../features/gmap/gmapApplicationTasklist/ApplicationTasklist'
import "./GmapApplicationTasklist.scss";

export default function GmapApplicationTasklist() {
  return (
    <ApplicationTasklist />
  )
}
